/**
 * Divider component for separating OAuth and email authentication options
 */
export function AuthDivider() {
  return (
    <div className="mb-4 flex items-center gap-3 text-[11px] font-medium text-muted-foreground">
      <span className="h-px flex-1 bg-border" aria-hidden />
      <span>or use email</span>
      <span className="h-px flex-1 bg-border" aria-hidden />
    </div>
  );
}
